import * as StateLib from "@/Utils/StateLib";
import React, { Fragment } from "react";
import { HorizontalToolbar, Divider } from "@theorgchartdev/storybook";
import BoxFormatToolsComposite from "./BoxFormatToolsComposite/BoxFormatToolsComposite";
import TextFormatToolsComposite from "./TextFormatToolsComposite/TextFormatToolsComposite";
import { useWSMgrContext } from "@/providers/WsMgrProvider";
import { RenderToolbarContent } from "./ContextualToolbar";
import { GetToolbarStyle } from "./ContextualToolbar";
import { PhotoCellToolsComposite } from "./PhotoCellToolsComposite/PhotoCellToolsComposite";
import BoxHeightPopover from "./BoxSizePopovers/BoxHeightPopover";
import BoxWidthPopover from "./BoxSizePopovers/BoxWidthPopover";
import GutterPopover from "./GutterPopover/GutterPopover";
import { enumChartElement } from "@coreapp/constants";
import { Globals } from "@coreapp/CoreApp/Globals";
import PreviewPersonSelect from "./PreviewPersonSelect/PreviewPersonSelect";

const dividerClass = "ocn-toolbar-horizontal-divider";

const ContextualToolbarBoxLayoutEditor = () => {
  const { wsMgr } = useWSMgrContext();
  let workspaceMgr = StateLib.GetWSMgr();
  let firstSelectedCell = null;
  let firstSelectedBox = null;
  let isPicture = false;
  const currentLayout = workspaceMgr?.GetBLELayout();
  const currentPanel = workspaceMgr?.GetCurrentPanel();

  if (!currentLayout || !currentPanel) return;

  if (workspaceMgr) {
    firstSelectedCell = workspaceMgr.GetFirstSelectedElement(enumChartElement.boxCell);
    isPicture = false;
    firstSelectedBox = workspaceMgr.GetFirstSelectedBox(true);
    if (firstSelectedBox) isPicture = firstSelectedBox.IsStaticPicture();
  }

  let showTextTools = true;
  if (isPicture && !firstSelectedCell) {
    showTextTools = false;
  }

  const leftContent = (
    <Fragment>
      <Fragment>
        <PreviewPersonSelect
          key={currentLayout.GetBoxStyleID()}
          panel={currentPanel}
          layout={currentLayout}
        />
        <div className={dividerClass}>
          <Divider vertical={true} />
        </div>
        <BoxWidthPopover layout={currentLayout} />
        <BoxHeightPopover layout={currentLayout} />
        <GutterPopover layout={currentLayout} />
        <div className={dividerClass}>
          <Divider vertical={true} />
        </div>
        <BoxFormatToolsComposite />
        <div className={dividerClass}>
          <Divider vertical={true} />
        </div>
      </Fragment>
      {(firstSelectedCell || firstSelectedBox) && (
        <Fragment>
          {showTextTools && (
            <Fragment>
              <TextFormatToolsComposite
                dataTestIdPrefix={"ctx-toolbar-ble"}
                showFieldDisplay={!Globals._uiConfig.fBLEHoverBarEnabled}
              />
              <div className={dividerClass}>
                <Divider vertical={true} />
              </div>
            </Fragment>
          )}
          {firstSelectedCell && <PhotoCellToolsComposite dataTestIdPrefix="ctx-toolbar-" />}
        </Fragment>
      )}
    </Fragment>
  );

  return (
    <HorizontalToolbar
      style={GetToolbarStyle(true)}
      leftContent={RenderToolbarContent() ? leftContent : null}
    />
  );
};

export default ContextualToolbarBoxLayoutEditor;
